import React, { ReactNode } from "react";
import FTSecNavOptions from "../ftConstants";
import Tab from "../../../generic/tab";
import { useRouteMatch, useParams } from "react-router-dom";
import "../../../../assets/scss/components/generic/layout/layoutTab.scss";
import "../../../../assets/scss/components/toc/fundTransfer/ftContainer/ftContainerTab.scss";

export interface IFtContainerTabProps {
	instComp?: ReactNode;
}

const FtContainerTab: React.FC<IFtContainerTabProps> = (props) => {
	const routeParams = useRouteMatch();

	const { asset } = useParams<{ asset: string }>(); //section navigation,page navigation, primary market instrument

	const defaultValue: string = routeParams.url.split("/")[2] + (asset ? asset : "");

	return (
		<section className={"outer_container container_tab  "}>
			<section className="lyCont tab">
				<section className="ly_listing_tab">
					<div className="ly_tbl_header">
						<div className={"list_info_tab"}>
							<Tab defaultValue={defaultValue} tabList={FTSecNavOptions()} position="center" />
						</div>
					</div>
					<div className={"list_details_tab ftForm"}>{props.instComp}</div>
				</section>
			</section>
		</section>
	);
};

export default FtContainerTab;
